import { render, staticRenderFns } from "./Expeditors.vue?vue&type=template&id=04631498&scoped=true&"
import script from "./Expeditors.vue?vue&type=script&lang=js&"
export * from "./Expeditors.vue?vue&type=script&lang=js&"
import style0 from "./Expeditors.vue?vue&type=style&index=0&id=04631498&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04631498",
  null
  
)

export default component.exports